import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import {Button} from 'react-bootstrap'
import heading from './assets/meetra_long.png'
import Footer from './Footer';
import fire from "./firebase/config";
import 'firebase/firestore';
import Select from 'react-select'

export default function ExistingTrainings() {
    const db = fire.firestore();
    const history = useHistory();
    const [trainingList, setTrainingList] = useState();
    const getData = async () => {
        console.log("HEYY")
        const trainings = [];
        const data = await db.collection("training").get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                trainings.push(doc.data());
                });
        });
        setTrainingList(trainings);
        console.log(trainingList)
    }
    useEffect (() => {
        getData()
    },[])
    return (
        <div>
            <div className="main-container">
                <center><img src={heading} width="70%"></img></center>
                <hr/>
                <div className="head">
                <h1>Existing Trainings</h1>
                <Button className="btn1-signout" type="submit" onClick={() => history.push({pathname:'/Admin'})}>Dashboard</Button></div>
                <hr/>
                <div className="flexbox-container">
                    <label>Pre-Training:</label>
                    <label>Google Meet:</label>
                    <label>Post-Training:</label>
                    <label>Feedback:</label>
                    <label>Certificate:</label>
                </div>
            </div>
            <Footer/>
        </div>
    )
}
